import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const prefersReducedMotion = () =>
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/**
 * Fade + slide up on scroll.
 */
export function revealUp(el, options = {}) {
  if (!el || prefersReducedMotion()) return;

  gsap.fromTo(
    el,
    { autoAlpha: 0, y: options.y ?? 40, x: options.x ?? 0 },
    {
      autoAlpha: 1,
      y: 0,
      x: 0,
      duration: options.duration ?? 0.7,
      ease: options.ease ?? 'power3.out',
      delay: options.delay ?? 0,
      scrollTrigger: {
        trigger: options.trigger ?? el,
        start: options.start ?? 'top 85%',
        toggleActions: 'play none none reverse',
      },
    },
  );
}

/**
 * Staggered reveal for children inside a container.
 */
export function revealStagger(container, selector, options = {}) {
  if (!container || prefersReducedMotion()) return;

  const items = container.querySelectorAll(selector);
  if (!items.length) return;

  gsap.fromTo(
    items,
    { autoAlpha: 0, y: options.y ?? 28, x: options.x ?? 0 },
    {
      autoAlpha: 1,
      y: 0,
      x: 0,
      duration: options.duration ?? 0.55,
      stagger: options.stagger ?? 0.1,
      ease: options.ease ?? 'power3.out',
      scrollTrigger: {
        trigger: container,
        start: options.start ?? 'top 82%',
        toggleActions: 'play none none reverse',
      },
    },
  );
}

/**
 * Horizontal line grow (scaleX).
 */
export function revealLine(el, options = {}) {
  if (!el || prefersReducedMotion()) return;

  gsap.fromTo(
    el,
    { scaleX: 0, transformOrigin: 'left center' },
    {
      scaleX: 1,
      duration: options.duration ?? 0.55,
      ease: 'power2.inOut',
      scrollTrigger: {
        trigger: options.trigger ?? el,
        start: options.start ?? 'top 88%',
        toggleActions: 'play none none reverse',
      },
    },
  );
}

/**
 * Progress bar fill (scaleX) — element keeps its CSS width.
 */
export function revealBar(el, options = {}) {
  if (!el || prefersReducedMotion()) return;

  gsap.fromTo(
    el,
    { scaleX: 0, transformOrigin: 'left center' },
    {
      scaleX: 1,
      duration: options.duration ?? 0.9,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: options.trigger ?? el.parentElement,
        start: options.start ?? 'top 85%',
        toggleActions: 'play none none reverse',
      },
    },
  );
}
